import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  tituloCampo: {
    marginBottom: theme.spacing(1),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  fieldDescricao: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
}))

export default useStyles
